/**
 * MatterSegregation.jsx — Subtab V
 */

import React from "react";
import { HSMVault } from "../diagrams.jsx";
import { SubtabHeading, GapBlock, SolutionLead, Body, P } from "../SubtabFrame.jsx";

export default function MatterSegregation() {
  return (
    <article>
      <SubtabHeading roman="V">Matter-Level Data Segregation</SubtabHeading>
      <HSMVault />
      <GapBlock>
        A single firm's environment hosts data from many matters, including
        matters with ethical walls. Standard AI systems don't respect these
        walls — context windows leak, embedding stores comingle, and prompt
        history creates cross-matter exposure.
      </GapBlock>
      <SolutionLead>
        Cryptographic and architectural matter isolation, not just policy-based
        isolation.
      </SolutionLead>
      <Body>
        <P>
          Each matter is provisioned as a logically isolated tenant with its
          own encrypted vector store, document corpus, and prompt history,
          encrypted with matter-specific keys held in a hardware security
          module (Thales Luna or AWS CloudHSM in on-prem configuration). The
          HSM enforces key access policy at hardware level — a user authorized
          for Matter A literally cannot decrypt Matter B's data even if they
          bypass application-level controls.
        </P>
        <P>
          Inference sessions are scoped to a single matter at session creation
          and cannot span matters. Cross-matter queries are architecturally
          impossible, not just disallowed. When a lawyer is staffed across two
          matters, they switch matter context explicitly, terminating the
          prior session and instantiating a new one with different keys and
          different retrieval scope.
        </P>
        <P>
          Embedding stores use per-matter Qdrant or Weaviate instances rather
          than shared vector databases, each running in its own container with
          its own encrypted storage volume. RAG retrieval is mathematically
          constrained to the matter scope; the system cannot retrieve
          documents the requesting session has no key for.
        </P>
        <P>
          Ethical walls are enforced through Active Directory / LDAP group
          membership tied to HSM key policies. Adding or removing a lawyer
          from a wall is a documented administrative action requiring dual
          authorization (typically the engaging firm's General Counsel plus
          the CoConsoleX supervising attorney) and is logged immutably.
        </P>
      </Body>
    </article>
  );
}
